import TumengNumberEdit from './src/index.vue'

TumengNumberEdit.install = function(Vue) {
  Vue.component(TumengNumberEdit.name, TumengNumberEdit)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengNumberEdit)
}

export default TumengNumberEdit
